<template>
  <template v-if="
    config.camera.payloadAsSelected &&
    $root.device_drone_measuretarget.hasOwnProperty(config.deviceFamilly.drone_det_id)
  ">
    <div
      class="bg-g0-dark py-1 px-2 hover:bg-flyingeye-light cursor-pointer mb-2 w-full flex justify-center items-center"
      :class="{'!bg-flyingeye': config?.openTelemetreLaser }"
      @click="openTelemetreLaser()"
    >
      <svg class="fill-current w-[16px]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 46.24 45.94">
        <path d="M45.23,20.95h-21.12c-.8-1.96-2.72-3.35-4.97-3.35-2.97,0-5.37,2.41-5.37,5.37s2.41,5.37,5.37,5.37c2.25,0,4.17-1.39,4.97-3.35h21.12c.55,0,1-.45,1-1v-2.04c0-.55-.45-1-1-1Z" />
        <path d="M18.14,30.9s-.07-.01-.11-.02c-.31-.05-.62-.1-.92-.18-1.04-.27-1.99-.74-2.82-1.37-.01-.01-.02-.03-.03-.04l-1.45-1.45s-.03-.02-.04-.03c-1.03-1.34-1.64-3.02-1.64-4.84s.62-3.5,1.64-4.84c.01-.01.03-.01.04-.03l1.45-1.45s.02-.03.03-.04c.83-.63,1.78-1.1,2.82-1.38.3-.08.61-.14.92-.18.04,0,.07-.01.11-.02.33-.04.66-.07.99-.07.7,0,1.38.1,2.02.27V1c0-.55-.45-1-1-1h-2.04c-.55,0-1,.45-1,1v10.51c-1.71.3-3.29.97-4.65,1.92l-4.52-4.52c-.39-.39-1.02-.39-1.41,0l-1.45,1.45c-.39.39-.39,1.02,0,1.41l4.52,4.52c-.96,1.36-1.62,2.94-1.92,4.65H1c-.55,0-1,.45-1,1v2.05c0,.55.45,1,1,1h6.68c.3,1.71.97,3.29,1.92,4.65l-4.52,4.52c-.39.39-.39,1.02,0,1.41l1.45,1.45c.39.39,1.02.39,1.41,0l4.52-4.52c1.37.96,2.94,1.62,4.65,1.92v10.51c0,.55.45,1,1,1h2.04c.55,0,1-.45,1-1v-14.24c-.65.17-1.32.27-2.02.27-.34,0-.67-.03-.99-.07Z" />
        <rect x="23.12" y="11.49" width="10.95" height="4.05" rx="1" ry="1" transform="translate(-1.18 24.18) rotate(-45)" />
        <rect x="26.57" y="26.96" width="4.05" height="10.95" rx="1" ry="1" transform="translate(-14.56 29.72) rotate(-45)" />
      </svg>
    </div>
  </template>
</template>
<script>
export default {
  name: "TelemetreLaser_btn",
  props: {
    config: Object,
  },
  setup() {
    return {
    };
  },
  methods: {
    openTelemetreLaser() {
      if(this.config?.openTelemetreLaser == undefined) {
        this.config.openTelemetreLaser = false;
      }

      this.config.openTelemetreLaser = !this.config.openTelemetreLaser;
    },
  },
};
</script>
